export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-disabled-1200-13a424f09f4224759338d146b6ea7335.png";